import { useSearchParams } from "react-router-dom";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/content";
import { ContactForm } from "../components/contact/ContactForm";
import { ContactSidebar } from "../components/contact/ContactSidebar";

export default function Contact() {
  const [searchParams] = useSearchParams();

  return (
    <main data-testid="contact-page" className="pt-20 md:pt-24">
      <section className="py-24 sm:py-28 border-b border-zinc-800/60">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">Request Service</span>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-none text-white mt-4 mb-6">
            Let's Get You<br />Back on the Road
          </h1>
          <p className="text-zinc-300 max-w-2xl leading-relaxed">
            Fill out the form below and we'll get back to you fast with an upfront quote.
            Need help right now? <a href={PHONE_TEL} className="text-blue-400 font-semibold" data-testid="contact-inline-call-link">Call {PHONE_DISPLAY}</a>.
          </p>
        </div>
      </section>

      <section className="py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-3">
            <ContactForm prefillService={searchParams.get("service")} />
          </div>
          <div className="lg:col-span-2">
            <ContactSidebar />
          </div>
        </div>
      </section>
    </main>
  );
}
